import * as React from 'react';

export interface PropertyBadgesProps {
  vipMessage?: string;
  propertyTypeBadge?: string;
}
export const PropertyBadges: React.FunctionComponent<PropertyBadgesProps> = ({ vipMessage, propertyTypeBadge }) => (
  <>
    {(propertyTypeBadge || vipMessage) && (
      <div className="uitk-cell all-cell-1-1 uitk-type-300 all-b-margin-one">
        {vipMessage && (
          <span className="uitk-type-medium" data-stid="property-vip">
            {vipMessage}
          </span>
        )}
        {vipMessage && propertyTypeBadge && <span className="uitk-type-bold all-x-margin-one">&#183;</span>}
        {propertyTypeBadge && (
          <span className="uitk-type-regular pwa-theme--grey-700" data-stid="property-structure-type">
            {propertyTypeBadge}
          </span>
        )}
      </div>
    )}
  </>
);
